/**
 * Superscript / subscript marks.
 *
 * The authors and affiliations blocks carry inline `<sup>` markers
 * ("Peng Xu<sup>1&dagger;</sup>"). StarterKit has no mark for them, so without
 * these the tags are stripped and every affiliation number runs into the name
 * beside it.
 */
import { Mark, mergeAttributes } from '@tiptap/core';

export const Superscript = Mark.create({
  name: 'superscript',
  parseHTML() {
    return [{ tag: 'sup' }];
  },
  renderHTML({ HTMLAttributes }) {
    return ['sup', mergeAttributes(HTMLAttributes), 0];
  },
});

export const Subscript = Mark.create({
  name: 'subscript',
  parseHTML() {
    return [{ tag: 'sub' }];
  },
  renderHTML({ HTMLAttributes }) {
    return ['sub', mergeAttributes(HTMLAttributes), 0];
  },
});
